module.exports = __webpack_public_path__ + "static/media/moxy.23874bc3.png";